require('./../Css/style.css');

import Player from '@vimeo/player';

function initTopImage() {
    initVimeoVideo();
}

function initVimeoVideo() {

    var vimeoOpenBtn = document.querySelector('.js-vimeo-open-btn');
    if (!vimeoOpenBtn) {
        return;
    }
    
    var vimeoCloseButtons = document.querySelectorAll('.js-vimeo-close-btn, .video-lightbox__overlay');
    
    const options = {
        id: vimeoOpenBtn.getAttribute('data-video'),
        width: 640,
        loop: true
    };
    
    const player = new Player('vimeoPlayer', options);

    vimeoOpenBtn.addEventListener("click", () => {
        player.play();
    });

    if (vimeoCloseButtons) {
        for (var i = 0; i < vimeoCloseButtons.length; i++){
                vimeoCloseButtons[i].addEventListener("click", () => {
                player.unload();
            });
        }
    }
}

export default initTopImage;


// WEBPACK FOOTER //
// ./Core/Shared/TopImage/Js/index.js